import { Box, Button, Card, CardContent, Typography } from '@material-ui/core'
import styles from '../styles'
import { RemoveRedEye } from '@mui/icons-material'
import moment from 'moment'
import AgDetail from './AgDetail'
import { openInNewTab } from '../../../utils'

export const CardView = ({
  record,
  setOpenDetail,
  openDetail,
  coproprietaire_id,
  copro_id,
  setFile,
}) => {
  const dateAgIsSameOrBeforeTomorrow = () => {
    const dateToCheck = record.datereelle
      ? moment(record.datereelle).startOf('day')
      : moment(record.dateprevisionnelle).startOf('day')

    const tomorrow = moment().add(1, 'day').startOf('day')

    return dateToCheck.isSameOrBefore(tomorrow)
  }
  const handleVisioConferenceClick = (e) => {
    e.preventDefault()
    if (record.visio_link && dateAgIsSameOrBeforeTomorrow()) {
      openInNewTab(record.visio_link)
    }
  }

  const handlePvAGButtonClick = (e) => {
    e.preventDefault()
    if (record.pv_ag) {
      setFile(record.pv_ag)
    }
  }

  const handleConvocationButtonClick = (e) => {
    e.preventDefault()
    if (record.convocation) {
      setFile(record.convocation)
    }
  }
  return (
    <Card style={styles.card}>
      <CardContent>
        <Box style={styles.row}>
          <Typography
            style={
              !record.visio_link || !dateAgIsSameOrBeforeTomorrow()
                ? styles.title
                : styles.titleLink
            }
            onClick={handleVisioConferenceClick}
          >
            {record.code}
          </Typography>
        </Box>
        <Box style={styles.row}>
          <Typography style={styles.date}>
            {record?.dateprevisionnelle
              ? moment(record.dateprevisionnelle).format('DD/MM/YYYY')
              : 'date non disponible'}
          </Typography>{' '}
          <Button
            style={styles.button}
            size="small"
            color="primary"
            onClick={handlePvAGButtonClick}
            disabled={!record.pv_ag}
            startIcon={<RemoveRedEye />}
          >
            Pv d'ag
          </Button>
        </Box>

        <Box style={styles.row}>
          <Button
            style={styles.button}
            onClick={handleConvocationButtonClick}
            disabled={!record.convocation}
            color="primary"
            size="small"
          >
            Convocation
          </Button>
          <Button
            style={styles.button}
            size="small"
            color="primary"
            disabled={new Date(record.dateprevisionnelle) < new Date()}
            onClick={() => {
              setOpenDetail(true)
            }}
          >
            Voir les résolutions
          </Button>
          <AgDetail
            setOpenDetail={setOpenDetail}
            openDetail={openDetail}
            record={record}
            coproprietaire_id={coproprietaire_id}
            copro_id={copro_id}
          />
        </Box>
      </CardContent>
    </Card>
  )
}
export default CardView
